export default "__VITE_ASSET__e5e91371__"